import { createGlobalStyle } from 'styled-components';

// Loads the Inter webfont used by `v2FontFamily` (styles/tokens.js). This
// component injects a scoped `@import` only while it's mounted, so the font
// request only happens on screens that render it.
export const V2FontImport = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700&display=swap');
`;
